










import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class Handle extends Vue {
  @Prop({ type: String, required: true }) label!: string;
  @Prop({ type: Boolean, required: true }) value!: boolean;
  @Prop({ type: Boolean, default: false }) disabled!: boolean;
  private initialState = this.value;

  private mounted() {
    if (this.disabled) {
      this.$emit("input", false);
    }
  }

  @Watch("disabled")
  private onDisabledChange() {
    if (!this.disabled) {
      this.$emit("input", this.initialState);
    }
  }

  private get icon() {
    if (!this.disabled) {
      return `chevron-${this.value ? "up" : "right"}`;
    } else {
      return "times";
    }
  }

  private onClick() {
    if (!this.disabled) {
      this.$emit("input", !this.value);
    }
  }
}
